import { gql } from '@apollo/client/core'

export const USER_INFO_QUERY = gql`
  query UserInfo {
    userInfo {
      user { id email role }
      refreshed
      accessToken
    }
  }
`

export const ROOMS_MINE_QUERY = gql`
  query RoomsMine {
    roomsMine {
      slug
      name
      childName
      endAt
      status
      visits
    }
  }
`

export const ROOMS_EXPIRED_QUERY = gql`
  query RoomsExpiredMine($limit: Int) {
    roomsExpiredMine(limit: $limit) {
      slug
      name
      childName
      endAt
      status
      visits
    }
  }
`

export const ROOM_GALLERY_QUERY = gql`
  query RoomGallery($slug: String!, $gameType: String!) {
    roomGallery(slug: $slug, gameType: $gameType) {
      id
      imageBase64
      topic
      createdAt
      analysisSummary
      positiveFeedback
      tags
      developmentalStage
      creativityScore
      emotionalState
      colorAnalysis
      shapeAnalysis
      parentAdvice
      analysisStatus
      fineMotorSkills
      creativityLevel
      attentionToDetail
      magicPrompt
      magicRequested
    }
  }
`

export const ROOM_PUZZLE_SESSIONS_QUERY = gql`
  query RoomPuzzleSessions($slug: String!) {
    roomPuzzleSessions(slug: $slug) {
      id
      imageBase64
      solutionBase64
      durationSeconds
      moves
      mode
      previewUsed
      gridSize
      success
      createdAt
      positiveFeedback
      analysisSummary
      tags
      problemSolvingScore
      focusLevel
       strategyAnalysis
       isSolved
       completionRatio
       analysisStatus
    }
  }
`

export const ROOM_SHAPES_SESSIONS_QUERY = gql`
  query RoomShapesSessions($slug: String!) {
    roomShapesSessions(slug: $slug) {
      id
      referenceBase64
      compositionBase64
      durationSeconds
      moves
      level
      shapeCount
      declaredDone
      success
      createdAt
      positiveFeedback
      analysisSummary
      tags
      shapeMatchingScore
      focusLevel
      strategyAnalysis
      isSolved
      completionRatio
      analysisStatus
    }
  }
`

export const ROOM_STORY_SESSIONS_QUERY = gql`
  query RoomStorySessions($slug: String!) {
    roomStorySessions(slug: $slug) {
      id
      roomSlug
      title
      createdAt
      messages { role text at }
      positiveFeedback
      analysisSummary
      tags
      kidRating
      communicationSkills
      emotionalTone
      storyUnderstanding
      parentAdvice
      analysisStatus
    }
  }
`

export const ROOM_LETTERS_SESSIONS_QUERY = gql`
  query RoomLettersSessions($slug: String!) {
    roomLettersSessions(slug: $slug) {
      id
      roomSlug
      letter
      referenceBase64
      traceBase64
      durationSeconds
      strokes
      level
      declaredDone
      success
      createdAt
      positiveFeedback
      analysisSummary
      tags
      letterFormationScore
      focusLevel
      strategyAnalysis
      isCorrect
      completionRatio
      analysisStatus
    }
  }
`

export const ROOM_MUSIC_SESSIONS_QUERY = gql`
  query RoomMusicSessions($slug: String!) {
    roomMusicSessions(slug: $slug) {
      id
      childName
      lyrics
      prompt
      createdAt
      positiveFeedback
      analysisSummary
      tags
      emotionalTone
      creativityScore
      rhymeQuality
      parentAdvice
      analysisStatus
    }
  }
`

export const CHECK_LETTER_MAGIC_STATUS_QUERY = gql`
  query CheckLetterMagicStatus($sessionId: String!) {
    checkLetterMagicStatus(sessionId: $sessionId) {
      id
      imageStatus
      imageUrl
    }
  }
`

export const CHECK_CONNECTION_STATUS_QUERY = gql`
  query CheckConnectionStatus($sessionId: String!) {
    checkConnectionStatus(sessionId: $sessionId) {
      id
      status
      analysis {
        magicTitle
        powerScore
        funnyCaption
        badges
        superheroName
      }
    }
  }
`

export const ROOM_CONNECTION_SESSIONS_QUERY = gql`
  query RoomConnectionSessions($slug: String!) {
    roomConnectionSessions(slug: $slug) {
      id
      missionType
      createdAt
      status
      steps {
        stepIndex
        imageBase64
      }
      analysis {
        magicTitle
        powerScore
        funnyCaption
        badges
        superheroName
      }
    }
  }
`